import { usePayment } from "../../contexts/PaymentContext";
import PaymentStatusBadge from "./ui/PaymentStatusBadge";

const RecentPayments = () => {
  const { offerings } = usePayment();
  const recentPayments = offerings?.slice(0, 5) || [];

  if (!recentPayments.length) {
    return (
      <div className="bg-white p-6 rounded-xl shadow-sm">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          Recent Donations
        </h3>
        <p className="text-gray-500">No recent donations found</p>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-xl shadow-sm">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Recent Donations
      </h3>
      <div className="space-y-4">
        {recentPayments.map((payment) => (
          <div key={payment.id} className="flex justify-between items-center pb-4 border-b border-gray-100">
            <div>
              <p className="font-medium text-gray-800">
                {payment.name || 'Anonymous'}
              </p>
              <p className="text-sm text-gray-500">
                {new Date(payment.createdAt).toLocaleDateString()}
              </p>
            </div>
            <div className="text-right">
              <p className="font-semibold text-gray-800">
                {payment.currency} {payment.amount.toFixed(2)}
              </p>
              <PaymentStatusBadge status={payment.status} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentPayments;